import React, { useEffect, useState, useMemo } from 'react';
import "../App.css";
import * as XLSX from 'xlsx';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SearchBox, getFilteredData } from "../components/Propertyfile";
import { TemplateReportStructure1, PaginationComponentForm2 } from "../components/TableProperty";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown, faListAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';

const SummaryReport = () => {
    const [formStructure, setFormStructure] = useState(null);
    const [selectedDownloadFormat, setSelectedDownloadFormat] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [columnsToDisplay, setColumnsToDisplay] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(5);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const textFileFormats = ["csv", "xlsx", "txt"];

    const handleFormatSelect = (format) => {
        setSelectedDownloadFormat(format);
        setShowDropdown(false);
    };

    // Get the stored value
    const reporttablename = localStorage.getItem("reporttablename");
    console.log("Report Table Name from localStorage:", reporttablename);

    // Clean again to ensure it's pure
    const cleanReportTableName = reporttablename
        ? reporttablename.replace(/(\.json$|_report$)/i, "")
        : "";

    console.log("Cleaned Report Table Name:", cleanReportTableName);

    const tableName = reporttablename
        ? reporttablename
            .replace(/(\.json$|_report$)/i, "")  // remove file suffixes
            .replace(/^[^_]*_/, "")              // remove prefix before first underscore
        : "";

    console.log("Cleaned Report Table Name:", cleanReportTableName);
    const autoIncrement = localStorage.getItem("autoIncrement");
    console.log("tableName:", tableName);

    useEffect(() => {
        const fetchTableData = async () => {
            try {
                setLoading(true);

                const reporttablename = localStorage.getItem("reporttablename");
                if (!reporttablename) throw new Error("Report table name not found");

                /* ------------------ 1️⃣ Fetch form structure ------------------ */
                const formResponse = await fetch(`/demformtemplate/${cleanReportTableName}.json`);
                if (!formResponse.ok) {
                    throw new Error("Select the Table");
                }
                const formStructure = await formResponse.json();

                // Template column order (lowercase)
                const templateColumns = formStructure.details
                    .filter(col => col.columnActive === "Y" || col.columnActive === "")
                    .map(col => col.columnName.toLowerCase());


                /* ------------------ 2️⃣ Fetch upload data ------------------ */
                const tableResponse = await fetch(`/uploads/${reporttablename}.json`);
                if (!tableResponse.ok) {
                    throw new Error("Error fetching table data");
                }
                const rawData = await tableResponse.json();

                if (!Array.isArray(rawData) || rawData.length === 0) {
                    setTableData([]);
                    setColumnsToDisplay([]);
                    return;
                }

                /* ------------------ 3️⃣ Upload file column set ------------------ */
                const uploadColumns = Object.keys(rawData[0]).map(col =>
                    col.toLowerCase()
                );

                /* ------------------ 4️⃣ INTERSECTION (template order wins) ------------------ */
                const finalColumns = templateColumns.filter(col =>
                    uploadColumns.includes(col)
                );

                /* ------------------ 5️⃣ Normalize upload rows ------------------ */
                const normalizedData = rawData.map(row => {
                    const normalizedRow = {};
                    Object.keys(row).forEach(key => {
                        normalizedRow[key.toLowerCase()] = row[key];
                    });
                    return normalizedRow;
                });

                /* ------------------ 6️⃣ Filter rows to FINAL columns only ------------------ */
                const filteredData = normalizedData.map(row => {
                    const orderedRow = {};
                    finalColumns.forEach(col => {
                        orderedRow[col] = row[col];
                    });
                    return orderedRow;
                });

                console.log("Final Columns to Display:", finalColumns);

                /* ------------------ 7️⃣ Set state ------------------ */
                setTableData(filteredData);
                setColumnsToDisplay(finalColumns);

            } catch (error) {
                console.error("Error:", error.message);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTableData();
    }, [autoIncrement]);


    const handleSearch = (event) => {
        const searchInput = event.target.value.trim().toLowerCase();
        setSearchTerm(searchInput);
        setCurrentPage(1);
    };

    const handleRecordsPerPageChange = (e) => {
        setRecordsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleDownloadClick = () => {
        if (!tableData || tableData.length === 0) {
            return;
        }

        // Helper function to get value case-insensitively
        const getCaseInsensitiveValue = (item, columnName) => {
            const lowerColumnName = columnName.toLowerCase();
            const actualKey = Object.keys(item).find(key => key.toLowerCase() === lowerColumnName);
            return actualKey ? item[actualKey] : item[columnName];
        };

        // Use the same columns that are displayed in the table
        const columnsToUse = columnsToDisplay;

        // Create cleaned data with case-insensitive value access
        const cleanedData = tableData.map(row => {
            const newRow = {};
            columnsToUse.forEach(key => {
                newRow[key] = getCaseInsensitiveValue(row, key);
            });
            return newRow;
        });

        const format = selectedDownloadFormat?.toLowerCase();

        if (format === 'csv') {
            const headers = columnsToUse;
            const csvRows = cleanedData.map(row => {
                const newRow = headers.map(header => {
                    const val = row[header];
                    return val != null ? `"${val.toString()}"` : '';
                });
                return newRow.join(",");
            });
            const csvContent = [headers.join(","), ...csvRows].join("\n");
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            triggerDownload(blob, `${cleanReportTableName}.csv`);
        }
        else if (format === 'json') {
            const blob = new Blob([JSON.stringify(cleanedData, null, 2)], { type: "application/json" });
            triggerDownload(blob, `${cleanReportTableName}.json`);
        }
        else if (format === 'xlsx') {
            const worksheet = XLSX.utils.json_to_sheet(cleanedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            triggerDownload(blob, `${cleanReportTableName}.xlsx`);
        }
        else if (format === 'txt') {
            const headers = columnsToUse;
            const txtRows = cleanedData.map(row =>
                headers.map(header => {
                    const val = row[header];
                    return typeof val === 'number' ? val.toString() : (val ?? '');
                }).join("\t")
            );
            const txtContent = [headers.join("\t"), ...txtRows].join("\n");
            const blob = new Blob([txtContent], { type: "text/plain;charset=utf-8;" });
            triggerDownload(blob, `${cleanReportTableName}.txt`);
        }
    };

    // Helper to trigger download
    const triggerDownload = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    };

    // Apply search filter

    // 1️⃣ Filter
    const filteredData = tableData.filter(item =>
        columnsToDisplay.some(column =>
            item[column]?.toString().toLowerCase().includes(searchTerm)
        )
    );

    // 2️⃣ Pagination helpers
    const indexOfLastItem = currentPage * recordsPerPage;
    const indexOfFirstItem = indexOfLastItem - recordsPerPage;

    // 3️⃣ Page slice
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    // 4️⃣ Total pages
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);

    // 5️⃣ Pagination handler
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // 6️⃣ Sort request
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    // 7️⃣ Sorted (ONLY affects visible page)
    const sortedData = useMemo(() => {
        if (!sortConfig.key) return currentItems;

        return [...currentItems].sort((a, b) => {
            let aVal = a[sortConfig.key];
            let bVal = b[sortConfig.key];

            if (aVal == null) return 1;
            if (bVal == null) return -1;

            // ✅ DATE SORT FIX
            if (sortConfig.key === 'reporting_date') {
                const aDate = new Date(aVal).getTime();
                const bDate = new Date(bVal).getTime();

                return sortConfig.direction === 'asc'
                    ? aDate - bDate
                    : bDate - aDate;
            }

            // ✅ NUMBER SORT
            if (typeof aVal === 'number' && typeof bVal === 'number') {
                return sortConfig.direction === 'asc'
                    ? aVal - bVal
                    : bVal - aVal;
            }

            // ✅ STRING SORT
            return sortConfig.direction === 'asc'
                ? aVal.toString().localeCompare(bVal.toString())
                : bVal.toString().localeCompare(aVal.toString());
        });
    }, [currentItems, sortConfig]);



    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />

            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className={`row m-2 rounded-1 ${styles.cardBorder}`}>
                            <div className={`col-lg-12 col-md-12`}>
                                <div className={`row m-2`}>
                                    <div className={`d-flex justify-content-between align-items-center pb-1 mb-2 ${styles.borderBottom}`}>
                                        <h6 className={`mb-0`}>
                                            {tableName.replace(/_/g, ' ').toUpperCase()}
                                        </h6>

                                        <div className="d-flex align-items-center ms-3">
                                            {/* Records Per Page Selector */}
                                            <div className="me-3">
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={recordsPerPage}
                                                    onChange={handleRecordsPerPageChange}
                                                    style={{ width: '70px' }}
                                                >
                                                    <option value="5">5</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>

                                            {/* Search Box */}
                                            <div>
                                                <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
                                            </div>

                                            {/* Download Button */}
                                            <div className="ms-3" style={{ marginRight: "27px" }}>
                                                <div
                                                    className="custom-dropdown position-relative"
                                                    onMouseEnter={() => setShowDropdown(true)}
                                                    onMouseLeave={() => setShowDropdown(false)}
                                                >
                                                    <button
                                                        className="btn btn-primary btn-sm btn-download"
                                                        onClick={handleDownloadClick}
                                                    >
                                                        {selectedDownloadFormat ? `Download (.${selectedDownloadFormat})` : "Download"}
                                                    </button>

                                                    {showDropdown && (
                                                        <ul className="dropdown-menu show text-start">
                                                            {textFileFormats.map((format) => (
                                                                <li key={format}>
                                                                    <button
                                                                        className="custom-dropdown-item"
                                                                        onClick={() => handleFormatSelect(format)}
                                                                    >
                                                                        .{format}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-12">
                                        <TemplateReportStructure1
                                            loading={loading}
                                            error={error}
                                            currentItems={sortedData}
                                            columnsToDisplay={columnsToDisplay}
                                            sortConfig={sortConfig}
                                            requestSort={requestSort}
                                        />

                                        {/* {filteredData.length > 5 && (
                                            <div className="d-flex justify-content-center mt-3">
                                                <nav>
                                                    <ul className="pagination">
                                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                                                            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                                                                <button onClick={() => paginate(number)} className="page-link">
                                                                    {number}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </nav>
                                            </div>
                                        )} */}
                                        {filteredData.length > 5 && (
                                            <PaginationComponentForm2
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                paginate={paginate}
                                                recordsPerPage={recordsPerPage}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default SummaryReport;